import {GenexLMSModel} from "@/models/lms/GenexLMSModel";
import Lesson from "@/models/lms/Lesson";
import ModuleLesson from "@/models/lms/ModuleLesson";
import ModuleQuiz from "@/models/lms/ModuleQuiz";
import ModuleEntity from "@/models/lms-central/ModuleEntity";
import UserLessonNote from "@/models/lms/UserLessonNote";
import Quiz from "@/models/lms/Quiz";
import GenexHelperMixins from "@/mixins/GenexHelperMixins";
import {LMSAssessment} from "@/models/lms/LMSAssessment";
import {normalize} from "@/utils/data";
import ModuleEntities from "@/models/lms-central/ModuleEntity";

export default class Module extends GenexLMSModel {
    static entity = 'modules'

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            // display_name: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            lessons: this.belongsToMany(Lesson, ModuleLesson, 'module_id', 'lesson_id'),
            quizzes: this.belongsToMany(Quiz, ModuleQuiz, 'module_id', 'quiz_id'),
            assessments: this.hasMany(LMSAssessment, 'module_id'),
            user_lesson_notes: this.hasMany(UserLessonNote, 'module_id'),
            completed: this.attr(null),
            order: this.attr(null),
            module_entities: this.hasMany(ModuleEntities, 'module_id')
        }
    }

    static FetchById(module_id, relationships = [], query = {}) {
        return this.api().get(`/modules/${module_id}`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
                params: {
                    ...{
                        with: relationships
                    }, ...(query !== {} ? query : {})
                },
                dataTransformer: ({data: {data}}) => {
                    return normalize(data)
                },
            }
        )
    }

}
